import ISettings from '../Interfaces/Settings';

/**
 * Slider breakpoint.
 *
 * @author Felix Kiesewetter <info@felixkiesewetter.de>
 * @package fk_js/slider
 * @lastModified 2026-06-11
 */
class Breakpoint
{

    #active = false; // TODO private

    public onEnter  :Function;
    public onLeave  :Function;
    public options  :ISettings;
    public minWidth :number;
    public maxWidth :number;

    /**
     * Breakpoint constructor.
     */
    constructor(
        minWidth :number = 0,
        maxWidth :number = Infinity,
        options  :ISettings|null = null,
        onEnter  :Function|null = null,
        onLeave  :Function|null = null,
    )
    {
        this.minWidth = minWidth;
        this.maxWidth = maxWidth;
        this.onEnter = onEnter;
        this.onLeave = onLeave;
        this.options = options;
        // TODO: Slider.addBreakpoint() method
    }

    /**
     * Check whether the breakpoint applies to given width
     *
     * @param {int} width
     * @returns {boolean}
     */
    applies(width)
    {
        return width >= this.minWidth && width <= this.maxWidth;
    }

    /**
     * Run breakpoint callback
     *
     * @param {Slider} parameters
     * @param parameters
     * @returns {Slider}
     */
    callback(callback, slider, ...parameters)
    {
        if (!this[callback] || Function !== this[callback].constructor) {
            return this;
        }
        this[callback](slider, this, ...parameters);
        return this;
    }

    /**
     * Public getter for the options object
     *
     * @returns {null|Object}
     */
    getOptions()
    {
        return this.options;
    }

    setActive(active)
    {
        this.#active = active;
        return this;
    }

    isActive()
    {
        return this.#active;
    }

}

export default Breakpoint;